import React, {FC} from 'react';

import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {DraftMessageModel} from '../../../../../../../libs/shared/core/src/models/api/messageModel';
import {useUserTheme} from '../../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {MessageBanner} from './messageBanner';
import {MessageBannerAction} from './messageBannerAction';
import {MessageBannerActionGroup} from './messageBannerActionGroup';
import {MessageBannerTitle} from './messageBannerTitle';

/*
 * Props.
 */

interface PendingDraftMessageBannerProps {
  message: DraftMessageModel;
  onCancelSendClick: () => void;
  isRounded: boolean;
}

/*
 * Component.
 */

export const PendingDraftMessageBanner: FC<PendingDraftMessageBannerProps> = (props) => {
  const theme = useUserTheme();

  return (
    <MessageBanner
      color={theme.palette.grey.shade50}
      iconName="outboxFilledSmall"
      isRounded={props.isRounded}
    >
      <MessageBannerTitle>
        <Trans id="pendingdraft-waiting">Waiting for connection</Trans>
      </MessageBannerTitle>
      <MessageBannerActionGroup>
        <MessageBannerAction onClick={props.onCancelSendClick}>
          <Trans id="pendingdraft-revert">Revert to draft</Trans>
        </MessageBannerAction>
      </MessageBannerActionGroup>
    </MessageBanner>
  );
};
